// extracted by mini-css-extract-plugin
export default {"pdf":"PDFStyles_pdf__LxXfB"};